import React, {Component} from "react";
import Title from "../../components/Title";
import Breadcrumbs from "../../components/UI/Breadcrumbs";
import Layout from "../../containers/Layout";
import ProfileFull from "../../containers/ProfileFull";


class ProfilePage extends Component {
    render() {
        return (
            <Layout>
                <Title>Профиль пользователя</Title>
                <Breadcrumbs links={[
                    {name: 'Главная', url: '/'},
                    {name: 'Профиль', url: `/profile`}
                ]}/>
                <ProfileFull/>
            </Layout>
        );
    }
}

export default ProfilePage;
